var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Titlebar',{attrs:{"title":_vm.$t('settings.title')}}),_c('div',{staticClass:"default-spacing is-paddingless-top"},[_c('SettingsHuntAreaCard'),_c('SettingsViltrapportIntegrationCard'),_c('SettingsLeaveOrRemoveCard')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }